// extracted by mini-css-extract-plugin
module.exports = {"loader":"PrivacyPolicyPage_loader__39LA7","heading":"PrivacyPolicyPage_heading__2EcCg","content":"PrivacyPolicyPage_content__2CC6M"};